var _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRipple25S120Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-ripple",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 19.8074,
    fill: "none",
    "ng-attr-stroke": "{{config.c1}}",
    "ng-attr-stroke-width": "{{config.width}}",
    stroke: "#3fae29",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    values: "0;40",
    keyTimes: "0;1",
    dur: 1.2,
    keySplines: "0 0.2 0.8 1",
    begin: "-0.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0",
    keyTimes: "0;1",
    dur: 1.2,
    keySplines: "0.2 0 0.8 1",
    begin: "-0.6s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 37.3408,
    fill: "none",
    "ng-attr-stroke": "{{config.c2}}",
    "ng-attr-stroke-width": "{{config.width}}",
    stroke: "#d7edd7",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    values: "0;40",
    keyTimes: "0;1",
    dur: 1.2,
    keySplines: "0 0.2 0.8 1",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0",
    keyTimes: "0;1",
    dur: 1.2,
    keySplines: "0.2 0 0.8 1",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple25S120Px);
export default __webpack_public_path__ + "static/media/Ripple-2.5s-120px.72154b8203a87eeccdb662b7442b3d68.svg";
export { ForwardRef as ReactComponent };